import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '@/views/LoginView.vue'
import { useAuth } from "@/store/auth"

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      requireAuth: true
    },
    component: HomeView
  },
  {
    path: '/login',
    name: 'LoginView',
    meta: {
      requireAuth: false
    },
    component: LoginView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const auth = useAuth()
  const isAuth = auth.token

  if((to.meta.requireAuth) && (isAuth == null)) {
    next("login")
  } else {
    next()
  }
})

export default router
